/**
 * Here all the menu items in the side bar listed
 */

export default [
  {
    url: '/',
    name: 'Dashboard',
    icon: 'home',
    i18n: 'Dashboard',
    permissionsToShow: ['all'],
    featuresToShow: ['all']
  },
  {
    url: '/users',
    name: 'System Users',
    icon: 'users',
    i18n: 'System Users',
    permissionsToShow: ['view_all_users'],
    featuresToShow: ['all']
  },
  {
    url: '/accounts',
    name: 'System Accounts',
    icon: 'accounts',
    i18n: 'System Accounts',
    permissionsToShow: ['view_all_accounts'],
    featuresToShow: ['all']
  },
  {
    url: '/campaigns/admin',
    name: 'System Campaigns',
    icon: 'campaigns',
    i18n: 'System Campaigns',
    permissionsToShow: ['list_all_campaigns'],
    featuresToShow: ['all']
  },
  {
    url: '/logs',
    name: 'System Logs',
    icon: 'info',
    i18n: 'System Logs',
    permissionsToShow: ['view_system_logs'],
    featuresToShow: ['system-logs']
  },
  {
    url: '/admin/fund',
    name: 'System Fund',
    icon: 'fund',
    i18n: 'System Fund',
    permissionsToShow: ['control_fund'],
    featuresToShow: ['all']
  },
  {
    url: '/admin/min-bid',
    name: 'MinBid',
    icon: 'min-bid',
    i18n: 'Min Bid',
    permissionsToShow: ['min_bid'],
    featuresToShow: ['all']
  },
  {
    url: '/features',
    name: 'Features',
    icon: 'features',
    i18n: 'Features',
    permissionsToShow: ['features'],
    featuresToShow: ['all']
  },
  {
    url: '/campaigns',
    name: 'Campaigns',
    icon: 'campaigns',
    i18n: 'Campaigns',
    permissionsToShow: ['list_personal_campaigns'],
    featuresToShow: ['all']
  },
  {
    url: '/ads',
    name: 'Ads',
    icon: 'ads',
    i18n: 'Ads',
    permissionsToShow: ['all'],
    featuresToShow: ['all']
  },
  {
    url: '/conversions',
    name: 'Conversions',
    icon: 'conversions',
    i18n: 'Tracking',
    permissionsToShow: ['all'],
    featuresToShow: ['all']
  },
  {
    url: '/reports',
    name: 'Reports',
    icon: 'report',
    i18n: 'Reports',
    permissionsToShow: ['personal_reports'],
    featuresToShow: ['all']
  },
  {
    url: '/targeting/audiences',
    name: 'Targeting',
    icon: 'targeting',
    permissionsToShow: ['personal_settings'],
    featuresToShow: ['all']
  },
  {
    url: '/settings/personal',
    name: 'Settings',
    icon: 'settings',
    i18n: 'Settings',
    permissionsToShow: ['personal_settings'],
    featuresToShow: ['all']
  }
]
